import { SVGProps } from 'react';

const Plus = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      d="M10 5V15M5 10H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Plus;
